import type { AppCopy } from '../catalogs';

export const esAppCopy = {
  welcomeHeading: '¿Cómo puedo ayudarte hoy?',
  thinking: 'Pensando',
  scrollToBottom: 'Desplazarse hacia abajo',
  reasoning: 'Razonamiento',
  reasoningInProgress: 'en progreso',
  citationPages: 'Páginas {first}–{last}',
  citationTitle: 'Extracto de la fuente',
  citationLoading: 'Cargando fuente…',
  citationUnavailable: 'El texto citado no está disponible o ya no tienes acceso.',
  citationOpen: 'Abrir fuente',
  citationCopied: 'Referencia copiada',
  copy: 'Copiar',
  more: 'Más',
  tryAgain: 'Inténtalo de nuevo',
  answerTruncated: 'La respuesta alcanzó el límite de longitud y quedó cortada.',
  continueAnswer: 'Continuar la respuesta',
  exportMarkdown: 'Exportar como descuento',
  edit: 'Editar',
  cancel: 'Cancelar',
  update: 'Actualizar',
  previous: 'Anterior',
  next: 'Siguiente',
  messagePlaceholder: 'Enviar un mensaje…',
  projectHomePlaceholder: 'Nuevo chat en {project}',
  sharedChatEveryone: 'Todos en {company} pueden leer este chat',
  sharedChatOnePerson: '1 persona puede leer este chat',
  sharedChatPeople: '{count} personas pueden leer este chat',
  forkedChatPlaceholder: 'Continúa con tus propias conexiones…',
  newAnswer: 'Nueva respuesta',
  messageInput: 'Entrada de mensaje',
  sendMessage: 'enviar mensaje',
  stopGenerating: 'dejar de generar',
  addAttachment: 'Agregar archivo adjunto',
  removeFile: 'Eliminar archivo',
  attachmentPreview: 'Vista previa del archivo adjunto',
  imageAttachmentPreview: 'Vista previa del archivo adjunto de imagen',
  image: 'Imagen',
  openLink: 'enlace abierto',
  document: 'Documento',
  file: 'Archivo',
  attachment: 'apego',
  uploadFailed: 'la carga falló',
  uploading: 'subiendo',
  toolIncomplete: 'Incompleto',
  toolActivity: 'Actividad',
  activityThinking: 'Pensando…',
  activityWriting: 'Escribiendo…',
  activityWaiting: 'Esperando tu aprobación',
  activityStopped: 'Detenido',
  activityCouldNotFinish: 'No se pudo completar',
  activitySources: 'fuentes',
  activityShowThinking: 'Mostrar razonamiento',
  activityOpen: 'Abrir actividad',
  activitySteps: 'Pasos',
  activitySourcesTab: 'Fuentes',
  activityUnavailable: 'Esta actividad no está disponible.',
  activityInput: 'Entrada',
  activityOutput: 'Salida',
  activityNoSources: 'Esta respuesta no citó fuentes.',
  activityApprovedByReply: 'Aprobado por tu respuesta',

  toolRunning: 'En curso',
  toolComplete: 'Completado',
  toolNeedsApproval: 'Requiere aprobación',
  toolInput: 'Entrada',
  toolCall: 'llamada de herramienta',
  toolCalls: 'llamadas de herramientas',
  openMenu: 'abrir menú',
  closeMenu: 'Cerrar menú',
  close: 'Cerrar',
  showInTextField: 'Mostrar en el campo de texto',
  settings: 'Configuración',
  appearance: 'Apariencia',
  themeLight: 'Claro',
  themeDark: 'Oscuro',
  themeSystem: 'Sistema',
  themeChoiceHelp:
    'Se aplica en todos tus dispositivos. «Sistema» sigue el modo claro u oscuro de cada dispositivo.',
  themeSaveFailed: 'No se pudo guardar la apariencia, así que no ha cambiado. Inténtalo de nuevo.',
  toolUsed: 'Herramienta utilizada',
  toolCancelled: 'Herramienta cancelada',
  toolResult: 'Resultado:',
  toolError: 'Error:',
  toolCancelledReason: 'Motivo de la cancelación:',
  approvalAllow: 'Permitir',
  approvalAlwaysAllow: 'Permitir siempre',
  approvalDeny: 'Rechazar',
  approvalAlwaysDeny: 'Rechazar siempre',
  approvalConfirm: 'Confirmar',
  approvalBack: 'Atrás',
  approvalApprovedResult: 'Aprobado por el usuario',
  approvalDeniedResult: 'El usuario rechazó la ejecución de la herramienta',
  logout: 'Cerrar sesión',
  loginOrCreateAccount: 'Iniciar sesión / Crear cuenta',
  newChat: 'Nuevo chat',
  untitledChat: 'Charla sin título',
  previousChats: 'Charlas anteriores',
  openChat: 'Abrir chat {title}',
  moreActionsForChat: 'Otras acciones para {title}',
  chatActions: 'Acciones de chat',
  closeChatActions: 'Cerrar acciones de chat',
  deleteChatQuestion: '¿Eliminar chat?',
  deleteChatDescription: 'El chat “{title}” se eliminará permanentemente.',
  deleteChat: 'Eliminar chat',
  keepChat: 'Conservar chat',
  delete: 'Eliminar',
  deleting: 'Eliminando…',
  chatDeleteFailed: 'No se pudo eliminar el chat. Intentar otra vez.',
  settingsDescription: 'Personaliza cómo funciona el asistente para ti.',
  settingsDesktopDescription: 'Personaliza cómo te responde el asistente.',
  personalization: 'Personalización',
  personalizationDescription:
    'Personaliza las instrucciones que sigue el asistente en cada respuesta.',
  languageAndRegion: 'Idioma y región',
  languageAndRegionDescription: 'Elige el idioma y la zona horaria.',
  memories: 'Recuerdos',
  memoriesDescription: 'Vea, edite o elimine lo que el asistente recuerda sobre usted.',
  account: 'cuenta',
  accountDescription: 'Gestionar la cuenta y eliminación permanente de sus datos.',
  backToSettings: 'Volver a la configuración',
  closeSettings: 'Cerrar configuración',
  settingsCategories: 'Categorías de configuración',
  yourSettings: 'Tu configuración',
  dataAndAccount: 'Datos y cuenta',
  viewAndManageMemories: 'Ver y gestionar lo que recuerda el asistente',
  loginToUseMemories: 'Inicia sesión para usar recuerdos',
  manageOrDeleteAccount: 'Administrar o eliminar la cuenta',
  unsavedChanges: 'Tienes cambios sin guardar',
  unsavedCloseDescription: 'Al cerrar la configuración se descartarán los cambios en esta página.',
  unsavedBackDescription: 'Al regresar se descartarán los cambios en esta página.',
  continueEditing: 'Continuar editando',
  discardChanges: 'Descartar cambios',
  saveChanges: 'Guardar cambios',
  localSettingsNote: 'Guardado en este navegador. Inicie sesión para guardar en su cuenta.',
  personality: 'Personalidad',
  personalityHelp: 'Instrucciones personalizadas que el asistente sigue en cada respuesta.',
  personalityPlaceholder:
    'Por ejemplo: Sea conciso y concreto. Vivo en Gotemburgo y me gusta la comida vegetariana.',
  timezone: 'Zona horaria',
  searchTimezone: 'Buscar zonas horarias…',
  automaticBrowser: 'Automático (navegador)',
  saved: 'Guardado {date}',
  addMemory: 'Añadir recuerdo',
  newMemory: 'Nuevo recuerdo',
  memoryPlaceholder: 'Por ejemplo: Prefiero respuestas cortas y concretas.',
  editMemory: 'Editar recuerdo',
  saveMemory: 'Guardar recuerdo',
  deleteMemory: 'Eliminar recuerdo',
  memorySaveFailed: 'No se pudo guardar la memoria. Intentar otra vez.',
  memoryLimitReached: 'Puedes guardar hasta 50 recuerdos. Elimina uno antes de añadir otro.',
  memoryInvalid:
    'Los recuerdos no pueden contener enlaces. Elimina el enlace e inténtalo de nuevo.',
  memoryDeleteFailed: 'No se pudo borrar la memoria. Intentar otra vez.',
  memoryLoadFailed: 'No se pudieron cargar los recuerdos.',
  loadingMemories: 'Cargando recuerdos…',
  emptyMemories:
    'El asistente guarda recuerdos sobre usted mientras habla: lo que le gusta, dónde vive y qué hace. Puede verlos, editarlos y eliminarlos aquí.',
  deleteAccountHelp:
    'Elimina permanentemente la cuenta y todos los chats, recuerdos y configuraciones relacionados.',
  deleteAccount: 'Eliminar cuenta',
  deleteAccountQuestion: '¿Eliminar permanentemente la cuenta?',
  deleteAccountDescription:
    'Se eliminarán todos los chats, mensajes, recuerdos, configuraciones y credenciales de inicio de sesión. Esta acción no se puede deshacer.',
  deleteAccountConfirm: 'Sí, eliminar mi cuenta',
  accountDeleteFailed: 'No se pudo eliminar la cuenta. No se eliminó nada; inténtalo de nuevo.',
  logoutEverywhereTitle: 'Todos los dispositivos',
  logoutEverywhereHelp:
    'Cierra sesión en todos los dispositivos y navegadores donde tu cuenta está abierta, incluido este.',
  logoutEverywhere: 'Cerrar sesión en todas partes',
  logoutEverywhereQuestion: '¿Cerrar sesión en todos los dispositivos?',
  logoutEverywhereDescription:
    'Tendrás que volver a iniciar sesión en todos los dispositivos y navegadores, incluido este. Tus chats y tu configuración se mantienen como están.',
  loggingOut: 'Cerrando sesión…',
  logoutEverywhereFailed:
    'No pudimos confirmar que se cerrara la sesión en todas partes. Inténtalo de nuevo o comprueba en otro dispositivo si sigues con la sesión iniciada.',
  settingsSaveFailed: 'No se pudieron guardar los ajustes. Intentar otra vez.',
  customInstructions: 'Instrucciones personalizadas',
  notSet: 'No establecido',
  automaticLanguage: 'Idioma automático',
  automaticTimezone: 'zona horaria automática',
  appLanguage: 'Idioma de la aplicación',
  appLanguageHelp:
    'Controla toda la interfaz de la aplicación y las fechas. Las respuestas del asistente siguen el idioma en el que escribes.',
  automaticBrowserLanguage: 'Automático (idioma del navegador)',
  previousLanguageChoice: 'Elección anterior: {language} ({locale})',
  previousLanguageChoiceCode: 'Elección anterior ({locale})',
  canvasCopyLink: 'Copiar enlace',
  canvasLinkCopied: 'Enlace copiado',
  actionUpdatedWithEdits: 'Actualizado con tus cambios',
  activityStepsDone: 'one:paso completado|other:pasos completados',
  activityResultsCount: 'one:resultado|other:resultados',
  canvasCopyLinkFailed: 'No se pudo copiar el enlace',
  canvasOpenInAgent: 'Abrir en {agent}',
  canvasExpand: 'Ampliar',
  canvasExitFullView: 'Salir de la vista completa',
  webSourceUnread:
    'Enlazado en esta respuesta. Poneva no leyó esta página, así que no hay nada que mostrar aquí.',
  webSourceOpenOriginal: 'Abrir original',
  toolProgressSettings: 'Cambiando tu configuración…',
  toolProgressAgent: 'Creando el agente…',
  toolProgressConnections: 'Buscando opciones de conexión…',
  toolProgressResult: 'Preparando tu resultado…',
  toolProgressClarification: 'Preparando una aclaración…',
  toolProgressKnowledge: 'Preparando una sugerencia de actualización del conocimiento…',
  toolProgressQuestion: 'Preparando una pregunta para ti…',
  toolProgressSkill: 'Dando forma a tu Skill…',
  toolErrorSettings: 'Tu configuración no se ha cambiado.',
  toolErrorAgent: 'No se pudo crear el agente.',
  toolErrorConnections: 'No se pudieron cargar las opciones de conexión.',
  toolErrorResult: 'El resultado no se ha guardado.',
  toolErrorClarification: 'No se pudo preparar la aclaración.',
  toolErrorKnowledge: 'No se pudo preparar la sugerencia de actualización del conocimiento.',
  toolErrorQuestion: 'No se pudo preparar la pregunta.',
  toolErrorSkill: 'No se pudo guardar el borrador de la Skill.',
  toolErrorOpenSettings: 'Abrir Configuración',
  toolErrorOpenAgents: 'Abrir Agentes',
  toolErrorOpenConnections: 'Abrir Conexiones',
  toolStepIncomplete: 'Este paso no se completó.',
  toolEarlierAttemptsFailed:
    'one:intento anterior no salió bien|many:de intentos anteriores no salieron bien|other:intentos anteriores no salieron bien',
} satisfies AppCopy;
